'use client';

import { forwardRef } from 'react';
import MuiPaper, { type PaperProps as MuiPaperProps } from '@mui/material/Paper';

export type PaperProps = MuiPaperProps;

export const Paper = forwardRef<HTMLDivElement, PaperProps>((props, ref) => {
  return <MuiPaper ref={ref} {...props} />;
});

Paper.displayName = 'Paper';
